module.exports = __webpack_public_path__ + "static/media/ppe.ca01d7a6.mp3";